import React from 'react';
import { Grid } from '@mui/material';
import PerfectScrollbar from 'components/SafePerfectScrollbar';
import ScalarDatasheet from 'components/ScalarDatasheet';
import { Cell, ValueEditor, ValueViewer } from 'components/Spreadsheet/components';
import { CompGroupsContext } from 'context';
import { TransactionsTableCompsProps } from './TransactionsTableComps.props';

const GpcTableComps = ({ onCellsChanged, transactionDataGrid }: TransactionsTableCompsProps) => {
  const contextValue = React.useMemo(() => ({ group: null, onCellsChanged }), [onCellsChanged]);

  return (
    <CompGroupsContext.Provider value={contextValue}>
      <Grid item xs={12} style={{ marginTop: '2rem' }}>
        {transactionDataGrid && (
          <PerfectScrollbar>
            <ScalarDatasheet
              data={transactionDataGrid}
              className="comp-datasheet gpc-table-comps"
              onCellsChanged={onCellsChanged}
              dataEditor={ValueEditor}
              valueViewer={ValueViewer}
              cellRenderer={Cell}
            />
          </PerfectScrollbar>
        )}
      </Grid>
    </CompGroupsContext.Provider>
  );
};

export default GpcTableComps;
